// internationalization
import type { TFunction } from 'i18next';

import { type DateTime, DateTime as LuxonDateTime } from 'luxon';

export interface DateRangePreset {
  key: string;
  label: string;
  getRange: () => { from: DateTime; to: DateTime };
}

// Labels come from the `view-data` namespace.
export const getDefaultPresets = (t: TFunction): DateRangePreset[] => [
  {
    key: 'last_hour',
    label: t('range_presets.last_hour'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.minus({ hours: 1 }), to: now };
    },
  },
  {
    key: 'last_24_hours',
    label: t('range_presets.last_24_hours'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.minus({ hours: 24 }), to: now };
    },
  },
  {
    key: 'last_3_days',
    label: t('range_presets.last_3_days'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.minus({ days: 3 }), to: now };
    },
  },
  {
    key: 'last_week',
    label: t('range_presets.last_week'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.minus({ days: 7 }), to: now };
    },
  },
  {
    key: 'last_month',
    label: t('range_presets.last_month'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.minus({ days: 30 }), to: now };
    },
  },
  {
    key: 'last_90_days',
    label: t('range_presets.last_90_days'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.minus({ days: 90 }), to: now };
    },
  },
  {
    key: 'ytd',
    label: t('range_presets.ytd'),
    getRange: () => {
      const now = LuxonDateTime.now();
      return { from: now.startOf('year'), to: now };
    },
  },
  {
    key: 'previous_year',
    label: String(LuxonDateTime.now().minus({ years: 1 }).year),
    getRange: () => {
      const previous = LuxonDateTime.now().minus({ years: 1 });
      return { from: previous.startOf('year'), to: previous.endOf('year') };
    },
  },
];
